<template>
  <body>
    <style-injector :appStyle="globalStyle" />
    <component :is="pageComponentName" />

    <div class="modal fade" id="alertModal" tabindex="-1" role="dialog" aria-labelledby="alertModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="alertModalLabel">哎呀!</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            {{errorMessage}}
          </div>
        </div>
      </div>
    </div>

    <div 
      id="app-spinner-wrapper"
      v-bind:style="[displaySpinner ? {display: ''} : {display: 'none'}]"
    >
      <div 
        id="app-spinner"
        class="spinner-border text-dark" 
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>

  </body>
</template>

<style>

#app-spinner-wrapper {
  z-index: 999;
  position: fixed;
  width: 100%;
  height:100%;
  display: flex;
  align-items: center;
  top: 0;
  background-color: #eee;
  opacity: 0.5;
}
#app-spinner {
  width: 3rem;
  height: 3rem;
  display: flex;
  margin: 0 auto;
}
</style>

<script>
import Vue from 'vue'
import StyleInjector from './StyleInjector'
import ValidateForm from './ValidateForm'
import SlideShow from './SlideShow'
import ImageAlbum from './ImageAlbum'
import StaticHtmlRender from './StaticHtmlRender'
import Init from './Init'
import $ from 'jquery'
import 'bootstrap'
import 'bootstrap'
import { default as cssUtils } from 'css'
import VueCarousel from 'vue-carousel'
import { mapActions, mapState, mapGetters, } from 'vuex'
import yaml from 'js-yaml'
import '../utils/checkout'
import { makeId } from '../utils'

Vue.use(VueCarousel)

Vue.component('style-injector', StyleInjector)
Vue.component('validate-form', ValidateForm)
Vue.component('slide-show', SlideShow)
Vue.component('image-album', ImageAlbum)
Vue.component('init', Init)

export default {
  name: 'PageRender',
  props: {
    id: {
      type: String,
      default: 'new',
    },
    sections: Array,
    globalStyle: {
      type: String,
      default: '',
    },
    routeParams: {
      type: Object,
      default() {
        return {}
      },
    },
    seoInfo: {
      type: String,
      default() {
        return ''
      },
    },
  },
  data() {
    this.createPageComponent('empty-page', '<div></div>')
    return {
      displaySpinner: false,
      showErrorMessage: false,
      errorMessage: '',
      pageComponentName: 'empty-page',
      counter: 0,
      debounceFunc: null,
    }
  },
  computed: {
    ...mapState({
      errors: state => state.page.errors,
      loadingCount: state => state.page.loadingCount,
      me: state => state.page.me,
      page: state => state.page
    })
  },
  methods: {
    ...mapActions({
      onQuery: 'page/onQuery',
    }),
    debounceSetupPage(waitTime) {
      if (this.debounceFunc) clearTimeout(this.debounceFunc)
      this.debounceFunc = setTimeout(() => {
        this.setupPage()
      }, waitTime ? waitTime : 500)
    },
    setupPage() {
      // For refresh page
      this.counter += 1
      
      // Build parameters
      let dynamicFieldsMap = {}
      let sectionActionsMap = {}
      let mergedVariables = {}
      const queryGraphqls = []
      const mutationGraphqls = []

      if (!this.sections || this.sections.length == 0) {
        return
      }

      for (const section of this.sections) {
        const staticData = null
        try {
          staticData = yaml.load(section.static_data)
        } catch(ignored) {
          console.warn(ignored)
        }
        const sectionStaticFields = {}
        sectionActionsMap[section.id] = []
        for (const key in staticData) {
          // custom fields
          if (!key.startsWith('__')) {
            sectionStaticFields[key] = staticData[key]
          }
          if (!(section.id in sectionActionsMap)) {
            sectionActionsMap[section.id] = []
          } else if (key === '__ACTIONS') {
            sectionActionsMap[section.id] = staticData[key]
          }
        }
        dynamicFieldsMap[section.id] = sectionStaticFields

        const filteredRouteParams = {}
        for (const key in this.routeParams) {
          if (':' + key !== this.routeParams[key]) {
            const value = this.routeParams[key]
            filteredRouteParams[key] = value
            if ('INIT_VARIABLES' in dynamicFieldsMap[section.id]) {
              dynamicFieldsMap[section.id].INIT_VARIABLES[key] = value
            }
          }
        }
        
        if ('INIT_QUERY' in dynamicFieldsMap[section.id]) {
          queryGraphqls.push(dynamicFieldsMap[section.id].INIT_QUERY)
          mergedVariables = {
            ...mergedVariables,
            ...dynamicFieldsMap[section.id].INIT_VARIABLES,
            ...filteredRouteParams,
          }
        } else if ('INIT_MUTATION' in dynamicFieldsMap[section.id]) {
          mutationGraphqls.push(dynamicFieldsMap[section.id].INIT_MUTATION)
          mergedVariables = {
            ...mergedVariables,
            ...dynamicFieldsMap[section.id].INIT_VARIABLES,
            ...filteredRouteParams,
          }
        }
      }

      if (mergedVariables.loggedInRedirectToHomePage && this.me.id) {
        const nextHref = this.$router.resolve({ 
          name: '首頁', 
        }).href
        window.location.replace(nextHref)
        return
      }

      const promise = new Promise((resolutionFunc, rejectionFunc) => {
        if (queryGraphqls.length > 0) {
          const mergedGraphql = this.mergeQueryGraphql(...queryGraphqls)
          return this.onQuery({
            query: mergedGraphql,
            variables: mergedVariables,
          }).then(data => {
            for (const key in dynamicFieldsMap) {
              dynamicFieldsMap[key].data = {
                ...dynamicFieldsMap[key].data,
                ...data,
              }
            }
            resolutionFunc()
          }, err => {
            console.error(err)
            rejectionFunc(err)
          })
        } else if (mutationGraphqls.length > 0) {
          const mergedGraphql = this.mergeMutationGraphql(...mutationGraphqls)
          return this.onQuery({
            query: mergedGraphql,
            variables: mergedVariables,
          }).then(data => {
            for (const key in dynamicFieldsMap) {
              dynamicFieldsMap[key].data = {
                ...dynamicFieldsMap[key].data,
                ...data,
              }
            }
            resolutionFunc()
          }, err => {
            console.error(err)
            rejectionFunc(err)
          })
        } else {
          resolutionFunc()
        }
      })

      promise.then(() => {
        for (const section of this.sections) {
          this.createSectionComponent('section-' + section.id, section.template, 
            dynamicFieldsMap[section.id], 
            section.style, 
            sectionActionsMap[section.id])
        }
        const pageTemplate = this.sections.map(section => {
          return '<section-' + section.id + ' />'
        }).join('\n')
        this.createPageComponent('page-' + this.id + '-' + this.counter, pageTemplate, this.page)
        this.pageComponentName = 'page-' + this.id + '-' + this.counter
      })
    },
    mergeQueryGraphql (...graphqls) {
      try {
        const params = {}
        const queries = []
        for (let graphql of graphqls) {
          const queryRegex = /query\(?(.*?)\)?{(.+)}/g
          graphql = graphql.replace(/[\r\n]+/g, ' ').replace(/\s+/g, ' ').trim()
          const match = queryRegex.exec(graphql)
          const matchGroup1 = match[1]
          const matchGroup2 = match[2]
          const paramKey = matchGroup1.split(':')[0]
          if (paramKey) {
            if (!(paramKey in params)) {
              params[paramKey] = matchGroup1
            } else {
              if (params[paramKey] !== matchGroup1) {
                throw Error('Got duplicated but different types query variables')
              }
            }
          }
          queries.push(matchGroup2)
        }
        let finalQuery = ''
        const paramValues = []
        if (Object.keys(params).length > 0) {
          finalQuery += 'query('
          for (const key in params) {
            paramValues.push(params[key])
          }
          finalQuery += paramValues.join(',')
          finalQuery += ')'
        } else {
          finalQuery += 'query'
        }
        finalQuery += '{'
        finalQuery += queries.join(' ')
        finalQuery += '}'
        return finalQuery
      } catch (ex) {
        console.error(ex)
      }
    },
    mergeMutationGraphql (...graphqls) {
      try {
        const params = {}
        const queries = []
        for (let graphql of graphqls) {
          const queryRegex = /mutation\(?(.*?)\)?{(.+)}/g
          graphql = graphql.replace(/[\r\n]+/g, ' ').replace(/\s+/g, ' ').trim()
          const match = queryRegex.exec(graphql)
          const matchGroup1 = match[1]
          const matchGroup2 = match[2]
          const paramKey = matchGroup1.split(':')[0]
          if (paramKey) {
            if (!(paramKey in params)) {
              params[paramKey] = matchGroup1
            } else {
              if (params[paramKey] !== matchGroup1) {
                throw Error('Got duplicated but different types query variables')
              }
            }
          }
          queries.push(matchGroup2)
        }
        let finalQuery = 'mutation('
        const paramValues = []
        for (const key in params) {
          paramValues.push(params[key])
        }
        finalQuery += paramValues.join(',')
        finalQuery += '){'
        finalQuery += queries.join(' ')
        finalQuery += '}'
        return finalQuery
      } catch (ex) {
        console.error(ex)
      }
    },
    createPageComponent(name, template) {
      Vue.component(name, {
        template: '<div>' + template + '</div>',
        mounted() {},
        data () {
          return {}
        },
      })
    },
    createSectionComponent(name, template, dynamicFields, style, actions) {
      var modifiedTemplate = template || ''
      if (modifiedTemplate.length > 0 && dynamicFields) {
        for (const key in dynamicFields) {
          modifiedTemplate = modifiedTemplate.split('${' + key + '}').join(dynamicFields[key])
        }
      }

      var finalTemplate = ""
      if (style != null && style.length > 0) {
        const uuid = makeId(10)
        const cssObj = cssUtils.parse(style)
        if (cssObj.stylesheet) {
          this.appendNamespaceForSelectors(cssObj.stylesheet.rules, '[' + uuid + '] ')
        }
        const scopedStyle = cssUtils.stringify(cssObj)
        finalTemplate = '<div ' + uuid + '><style-injector app-style="' + encodeURI(scopedStyle) + '"></style-injector>' + modifiedTemplate + '</div>'
      } else {
        finalTemplate = '<div>' + modifiedTemplate + '</div>'
      }
      const storeActions = {}
      for (const action of actions) {
        storeActions[action] = 'page/' + action
      }
      Vue.component(name, {
        components: {
          'static-html-render': StaticHtmlRender,
        },
        template: finalTemplate,
        computed: {
          ...mapState({
            page: state => state.page,
            me: state => state.page.me,
            fbLoginInfo: state => state.page.fbLoginInfo,
          }),
        },
        methods: {
          submitCheckoutForm,
          handleResize() {
            this.screenSize.innerWidth = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth)
            this.screenSize.innerHeight = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight)
          },
          btoa(rawString) {
            return window.btoa(rawString)
          },
          atob(encodedString) {
            return window.atob(encodedString)
          },
          setTimeout(handler, timeout) {
            return window.setTimeout(handler, timeout)
          },
          ...mapActions(storeActions),
        },
        mounted() {
          // Setup tooltip
          $('[data-toggle="tooltip"]').tooltip()
        },
        created() {
          window.addEventListener('resize', this.handleResize)
          this.handleResize()
        },
         destroyed() {
          window.removeEventListener('resize', this.handleResize);
        },
        data () {
          return {
            screenSize: {
              innerWidth: 0,
              innerHeight: 0,
            },
            ...dynamicFields,
          }
        },
      })
    },
    appendNamespaceForSelectors(rules, namespace) {
      for (var i = 0; i < rules.length; i++) {
        const rule = rules[i]
        if (rule.selectors) {
          for (var j = 0; j < rule.selectors.length; j++) {
            rule.selectors[j] = namespace + ' ' +  rule.selectors[j]
          }
        } else if (rule.rules) {
          this.appendNamespaceForSelectors(rule.rules, namespace)
        }
      }
    },
  },
  mounted () {
    this.debounceSetupPage()
  },
  destroyed () {
  },
  watch: {
    errors(newVal) {
      if (newVal && newVal && newVal.messages) {
        $('#alertModal').modal()
        this.errorMessage = newVal.messages.join("<br/>")
      }
    },
    loadingCount (newVal) {
      if (this.loadingCountTimeout) clearTimeout(this.loadingCountTimeout)
      this.loadingCountTimeout = setTimeout(() => {
        if (newVal > 0) {
          this.displaySpinner = true
        } else {
          this.displaySpinner = false
        }
      }, 500)
    },
    routeParams (to) {
      if (to) {
        console.log(to)
        this.debounceSetupPage()
      }
    },
    sections (newVal) {
      if (newVal) {
        this.debounceSetupPage()
      }
    }
  }
}
</script>